<template>
  <div class="trainer-board-filter trabordf">
    <SimpleTabs
      :value="l_tab"
      :options="tabs"
      style="--height: 2.5rem"
      :style="`--tab-radius: ${tabsHasRadius ? 4 : 0}px`"
      class="tabs-stretch tabs-highlight"
      @input="handleTabChange"
    >
      <template #default="v">
        {{ $t(`tabs.${v.item}`) }}
      </template>
    </SimpleTabs>
    <div class="trabordf_content small-scroll-track">
      <div class="theme-block-title mt-4 pb-1 d-flex">
        {{ $t('common.specific_board') }}

        <div class="ml-2 mdi mdi-help-circle-outline text-small csst clr-grey">
          <div
            class="csst_content clr-white text-medium"
            style="max-width: 24rem; min-width: 13rem"
            v-html="$t(`tooltips.board_cards`)"
          ></div>
        </div>
      </div>
      <div
        class="position-relative d-flex trabordf_checkbox-row trabordf_board mt-0"
        @click="openCardsDialog"
      >
        <CardRow
          style="--padding: 0.5em"
          size="medium"
          class="card-row_btn"
          :cards="fullBoard"
          :hasAnimation="false"
        />

        <div
          :class="{ 'opacity_0 no-events': fullBoard === 'EeEeEeEeEe' }"
          class="mdi mdi-close icon_btn text-semi-large my-auto pa-1 csst csst_nm text-nowrap"
          @click.stop="clearStreetBoard"
        >
          <div
            class="csst_content"
            style="position: absolute; top: -1.5rem"
            v-html="$t('common.clear_board')"
          ></div>
        </div>
      </div>

      <CheckboxRow
        v-for="item in streetOptions[l_tab]"
        :key="item.id"
        class="trabordf_checkbox-row"
        :item="item"
        :hasDragSelect="!mobile && item.hasDragSelect"
        :isSingle="item.isSingle"
        :style="item.style"
        @update="handleUpdate"
      >
        <template #title>
          <div class="position-relative d-flex">
            {{ item.title }}
            <div
              v-if="item.title_tooltip || item.title_dialog"
              :class="[{ csst: item.title_tooltip }, { 'icon_btn pa-1': item.title_dialog }]"
              class="mdi mdi-help-circle-outline text-small my-auto ml-1"
              style="color: var(--clr-grey-2)"
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
            >
              <div
                class="csst_content clr-white csst_content_hoverable"
                style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
              >
                <span v-html="item.title_tooltip"> </span>

                <span
                  v-if="!$i18n.g1 && item.title_tooltip_link"
                  class="clr-primary pl-1"
                >
                  <i class="mdi mdi-information mr-1"></i
                  ><span class="text-underline">
                    <a
                      :href="links_url_links.filter_subsets.url"
                      target="_blank"
                      v-html="item.title_tooltip_link"
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </template>

        <template #default="v">
          {{ item.id === 'flop_subset' ? v.id : $t(`practice.filter.${v.id}`) }}
        </template>
      </CheckboxRow>
    </div>
  </div>
</template>

<script>
import SimpleTabs from '@/components/AppBar/SimpleTabs'
import CardRow from '@/components/CardRow/CardRow'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import { getBoardFilterOptions } from '@/store/router/router'
import { getCardsByStreet, getFullBoardByStreet } from '@/helpers/cards'
import screen_mix from '@/mixins/screen_mix'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerBoardFilter',
  components: {
    CheckboxRow,
    CardRow,
    SimpleTabs,
  },
  mixins: [screen_mix, float_mix, links_mix],
  props: {
    namespace: { String, required: true },
    // isCollapsable: { type: Boolean,  default: true },
    tab: { default: () => 'flop' },
    tabsHasRadius: { type: Boolean, default: true },
    routerParams: {
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  data() {
    return {
      tabs: ['flop', 'turn', 'river'],
      l_tab: '',
      initialState: {
        board: '',
        boardQuery: null,
      },
    }
  },
  created() {
    this.l_tab = this.tabs.includes(this.tab) ? this.tab : this.tabs[0]
    this.initialQuery = {
      board: this.board,
      ...this.boardQuery,
    }
  },
  methods: {
    clear() {
      const ff = getBoardFilterOptions()
      const query = { board: '' }
      Object.keys(ff).forEach(key => {
        query[key] = ''
      })
      this.updateQuery(query)
    },
    clearStreetBoard() {
      let {board} = this
      board = ''
      this.updateQuery({ board })
    },
    openCardsDialog() {
      const dialog = `cards-dialog${this.namespace ? `_namespace-${this.namespace}` : ''}_board-tmp`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handleUpdate(item) {
      const res = { [item.id]: item.selected }
      this.updateQuery(res)
    },
    handleTabChange(item) {
      this.l_tab = item
    },
    updateQuery(query) {
      this.$store.dispatch(`${this.namespace ? `${this.namespace}/` : ''}router_update_query`, {
        query,
        ...this.routerParams,
      })
    },
  },
  computed: {
    fullBoard() {
      const res = getFullBoardByStreet(this.board, 'river')
      return res
    },
    streetBoard() {
      const res = getCardsByStreet(this.board, 'river')
      return res
    },
    ch_board() {
      const res = {
        id: 'board_filters',
        title: this.$t('shortcut.board'),
        options: ['custom'],
        selected: this.board ? ['custom'] : [],
      }
      return res
    },
    streetOptions() {
      const res = {}
      const bl = this.board.length
      Object.keys(this.boardQuery).forEach(key => {
        const street = key.split('_')[0]
        const ff = getBoardFilterOptions()
        //
        const options = ff[key]
        const bq = this.boardQuery[key]
        const selected = bq.split(',').filter(i => i)
        const anyDisabled = street === 'flop' ? bl > 0 : street === 'turn' ? bl > 6 : bl > 8
        const disabled = anyDisabled ? options : []

        const tooltipKey = `board_${key
          .replace('flop_', '')
          .replace('turn_', '')
          .replace('river_', '')}`
        const isSingle = key === 'flop_subset'
        const style = isSingle ? '--clr-row-back: var(--clr-black-1-2)' : ''
        const item = {
          id: key,
          title: this.$t(`practice.filter.${key}`),
          title_tooltip: this.$t(`tooltips.${tooltipKey}`),
          title_tooltip_link: key === 'flop_subset' ? this.$t(`tooltips.more_about_subsets`) : '',
          style,
          options,
          selected,
          disabled,
          isSingle,
          anyDisabled,
          allDisabled: disabled.length === options.length,
          hasDragSelect: key.includes('card') && street === 'flop',
        }
        res[street] = [...(res[street] || []), item]
      })
      return res
    },
    board() {
      const res = this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}query_board`]
      return res
    },
    boardQuery() {
      const res =
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}query_board_filter`]
      return res
    },
  },
}
</script>
<style lang="scss">
.trabordf {
  max-width: 100%;
  --row-padding: 0;
  --padding-content: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  &_content {
    min-height: 33rem;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 1px;
  }
  &_checkbox-row {
    padding: var(--row-padding);
    margin-top: 1rem;
  }
}
</style>
